import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export const confirmAction = async ({
  title = 'Are you sure?',
  message = 'Are you sure you want to delete this?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isHtml = false
}) => {
  // On <body>, which is where setResolvedTheme puts it. Read off
  // documentElement this was never anything but null, so every confirmation
  // came up white however the rest of the app was themed.
  const isDark = document.body.getAttribute('data-pc-theme') === 'dark';

  return Swal.fire({
    title,
    ...(isHtml ? { html: message } : { text: message }),
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,

    width: '340px',
    padding: '0.8em',

    background: isDark ? '#1e293b' : '#ffffff',
    color: isDark ? '#ffffff' : '#000000',

    customClass: {
      popup: 'popup-custom swal-high-zindex'
    },

    didOpen: () => {
      const icon = document.querySelector('.swal2-icon');
      if (icon) {
        icon.style.transform = 'scale(0.65)';
        icon.style.margin = '0 auto 0.25em';
      }
      const title = document.querySelector('.swal2-title');
      if (title) title.style.padding = '0.25em 0 0';
      const content = document.querySelector('.swal2-html-container');
      if (content) content.style.margin = '0.25em 0 0';
      const actions = document.querySelector('.swal2-actions');
      if (actions) actions.style.marginTop = '0.6em';
    }
  }).then((result) => result.isConfirmed);
};
